import Typography from '../../../../../../components/Typography';
import usePublishedPollTitle from './vm';

export interface PublishedPollTitleProps {
  className?: string;
}

const PublishedPollTitle = ({ className }: PublishedPollTitleProps) => {
  const { pollTitle } = usePublishedPollTitle();

  return (
    <Typography variant="h4Medium" color="common.black" noWrap className={className}>
      {pollTitle}
    </Typography>
  );
};

export default PublishedPollTitle;
